import * as React from "react";
import type {
	ControlSize,
	ResponsiveClassMap,
	ResponsiveProperty,
} from "./types";

export function useResponsiveSize(
	size: ResponsiveProperty<ControlSize>,
	classMap: ResponsiveClassMap<ControlSize>,
): Array<string> {
	const classList = React.useMemo(() => {
		const [
			defaultSize,
			sizeAtWiderThanSm,
			sizeAtWiderThanMd,
			sizeAtWiderThanLg,
			sizeAtWiderThanXl,
			sizeAtWiderThanXxl,
		] = typeof size === "string" ? [size] : size;

		return [
			defaultSize && classMap[defaultSize]["default"],
			sizeAtWiderThanSm && classMap[sizeAtWiderThanSm]["sm"],
			sizeAtWiderThanMd && classMap[sizeAtWiderThanMd]["md"],
			sizeAtWiderThanLg && classMap[sizeAtWiderThanLg]["lg"],
			sizeAtWiderThanXl && classMap[sizeAtWiderThanXl]["xl"],
			sizeAtWiderThanXxl && classMap[sizeAtWiderThanXxl]["2xl"],
		].filter(Boolean) as Array<string>;
	}, [classMap, size]);

	return classList;
}
